<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-overlay :value="!loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- /<Strong>Note : If any data is not available or applicable.Kindly mention NA </Strong> -->
        <v-form id="contact_form" @submit.prevent="submit" v-model="isValid" v-if="loader">
            <v-row dense justify="center">
                <v-col cols="10" sm="10" md="10"> <input type="hidden" :value="application_form_data.admission_form_id"
                        name="admission_form_id" /> </v-col>
            </v-row>
            <!-- <template v-if="tenant != 'uwws'"> -->
            <template v-if="user_type == 'Employee'">
                <v-row dense justify="center" v-if="true">
                    <v-col cols="10" sm="4" md="4">
                        <v-text-field dense type="email" v-model="personal_email.field_value"
                            :name="personal_email.field_name" hint="*Email/Login-ID" persistent-hint single-line
                            outlined prepend-icon="mdi-contact-mail"></v-text-field>
                    </v-col>
                    <v-col cols="10" sm="4" md="4">
                        <v-text-field dense type="number" v-model="mobile_no.field_value" :name="mobile_no.field_name"
                            hint="*Mobile Number" persistent-hint single-line outlined prepend-icon="mdi-contact-phone"
                            :rules="mobile_no.required ? [
                                v => !!v || 'Telephone Number is required',
                                v => (v && v.length == 10) || 'Telephone Number Must be 10 digit'
                            ] : [v => ((v == null || v == '') ? true : (v.length == 0 || v.length == 10)) || 'Telephone Mobile Number Must be 10 digit']"></v-text-field>
                    </v-col>
                </v-row>
            </template>
            <template v-if="false">
                <v-row dense justify="center" v-if="true">
                    <v-col cols="10" sm="10" md="10">
                        <v-icon color="error" v-if="true">*</v-icon>
                        <v-text-field dense type="email" v-model="personal_email.field_value"
                            :name="personal_email.field_name" required="true" :disabled="disable_personal_email"
                            :rules="true ? [
                                v => !!v || 'Email is required',
                                v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                            ] : [v => ((v == null || v == '') ? true : (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v))) || 'E-mail must be valid']" counter hint="Email" persistent-hint single-line outlined
                            :clearable="false"
                            :prepend-icon="personal_email.field_value != null ? 'mdi-contact-mail' : 'mdi-contact-mail-outline'"></v-text-field>
                    </v-col>
                </v-row>
                <v-row dense justify="center" v-if="true">
                    <v-col cols="10" sm="10" md="10">
                        <v-icon color="error" v-if="true">*</v-icon>
                        <v-text-field dense type="number" v-model="mobile_no.field_value" :disabled="disable_mobile_no"
                            :name="mobile_no.field_name" required="true" :rules="true ? [
                                v => !!v || 'Mobile Number is required',
                                v => (v && v.length == 10) || 'Mobile Number Must be 10 digit'
                            ] : [v => ((v == null || v == '') ? true : (v.length == 0 || v.length == 10)) || 'Mobile Number Must be 10 digit']"
                            counter maxlength="10" hint="Mobile Number" persistent-hint single-line outlined
                            :clearable="false"
                            :prepend-icon="mobile_no.field_value != null ? 'mdi-contact-phone' : 'mdi-contact-phone-outline'"></v-text-field>
                    </v-col>
                </v-row>
            </template>
            <v-row dense justify="center" v-if="alternate_mobile_no">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="alternate_mobile_no.required">*</v-icon>
                    <v-text-field dense type="number" v-model="alternate_mobile_no.field_value"
                        :name="alternate_mobile_no.field_name" :required="alternate_mobile_no.required"
                        :rules="alternate_mobile_no.required ? [v => !!v || 'Alternate Mobile Number is required', v => (v && v.length == 10) || 'Alternate Mobile Number Must be 10 digit'] : [v => ((v == null || v == '') ? true : (v.length == 0 || v.length == 10)) || 'Alternate Mobile Number Must be 10 digit']"
                        counter maxlength="10" hint="Alternate Mobile Number" persistent-hint single-line outlined
                        :clearable="alternate_mobile_no.required ? false : true"
                        :prepend-icon="alternate_mobile_no.field_value != null ? 'mdi-contact-phone' : 'mdi-contact-phone-outline'"></v-text-field>
                </v-col>
            </v-row>

            <v-row dense justify="center" v-if="telephone_no">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="telephone_no.required">*</v-icon>
                    <v-text-field dense type="number" v-model="telephone_no.field_value" :name="telephone_no.field_name"
                        :required="telephone_no.required"
                        :rules="telephone_no.required ? [
                            v => !!v || 'Telephone Number is required',
                            v => (v && v.length == 10) || 'Telephone Number Must be 10 digit'
                        ] : [v => ((v == null || v == '') ? true : (v.length == 0 || v.length == 10)) || 'Telephone Mobile Number Must be 10 digit']" counter maxlength="10"
                        hint="Telephone no." persistent-hint single-line outlined
                        :clearable="telephone_no.required ? false : true"
                        :prepend-icon="telephone_no.field_value != null ? 'mdi-phone-classic' : 'mdi-phone-classic'"></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <v-col cols="10" sm="10" md="10">
                    <h4>Guardian Details</h4>
                </v-col>
            </v-row>


            <v-row dense justify="center" v-if="guardian_name_sbpps">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="guardian_name_sbpps.required">*</v-icon>
                    <v-text-field dense type="text" v-model="guardian_name_sbpps.field_value"
                        :name="guardian_name_sbpps.field_name" :required="guardian_name_sbpps.required"
                        :rules="guardian_name_sbpps.required ? [v => !!v || 'Guardian Contact Name is required'] : []"
                        :hint=guardian_name_sbpps.field_display_name persistent-hint single-line outlined
                        :clearable="guardian_name_sbpps.required ? false : true"
                        prepend-icon="mdi-account-circle"></v-text-field>
                </v-col>
            </v-row>

            <v-row dense justify="center" v-if="guardian_contact_sbpps">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="guardian_contact_sbpps.required">*</v-icon>
                    <v-text-field dense type="number" v-model="guardian_contact_sbpps.field_value"
                        :name="guardian_contact_sbpps.field_name" :required="guardian_contact_sbpps.required"
                        :rules="guardian_contact_sbpps.required ? [
                            v => !!v || 'Contact Number is required',
                            v => (v && v.length == 10) || 'Contact Number Must be 10 digit'
                        ] : [v => ((v == null || v == '') ? true : (v.length == 0 || v.length == 10)) || 'Contact Number Must be 10 digit']" counter maxlength="10" :hint=guardian_contact_sbpps.field_display_name
                        persistent-hint single-line outlined :clearable="guardian_contact_sbpps.required ? false : true"
                        prepend-icon="mdi-phone-classic"></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="guardian_email_sbpps">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="guardian_email_sbpps.required">*</v-icon>
                    <v-text-field dense type="text" v-model="guardian_email_sbpps.field_value"
                        :name="guardian_email_sbpps.field_name" :required="guardian_email_sbpps.required"
                        :rules="guardian_email_sbpps.required ? [
                            v => !!v || 'Email is required',
                            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                        ] : [v => ((v == null || v == '') ? true : (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v))) || 'E-mail must be valid']" :hint=guardian_email_sbpps.field_display_name
                        persistent-hint single-line outlined :clearable="guardian_email_sbpps.required ? false : true"
                        prepend-icon="mdi-email"></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="guardian_address_sbpps">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="guardian_address_sbpps.required">*</v-icon>
                    <v-textarea dense clear-icon="cancel" v-model="guardian_address_sbpps.field_value"
                        :value="guardian_address_sbpps.field_value" :name="guardian_address_sbpps.field_name"
                        :required="guardian_address_sbpps.reuired"
                        :rules="guardian_address_sbpps.required ? [v => !!v || 'Address is required'] : []"
                        :hint=guardian_address_sbpps.field_display_name persistent-hint single-line outlined
                        :clearable="guardian_address_sbpps.required ? false : true"
                        :prepend-icon="guardian_address_sbpps.field_value != null ? 'mdi-home-circle' : 'mdi-home-circle-outline'"></v-textarea>
                </v-col>
            </v-row>

            <v-row dense justify="center" v-if="guardian_relation_sbpps">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="guardian_relation_sbpps.required">*</v-icon>
                    <v-text-field dense type="text" v-model="guardian_relation_sbpps.field_value"
                        :name="guardian_relation_sbpps.field_name" :required="guardian_relation_sbpps.required"
                        :rules="guardian_relation_sbpps.required ? [v => !!v || 'Guardian Relation With Child is required'] : []"
                        :hint=guardian_relation_sbpps.field_display_name persistent-hint single-line outlined
                        :clearable="guardian_relation_sbpps.required ? false : true"
                        prepend-icon="mdi-account-circle"></v-text-field>
                </v-col>
            </v-row>


            <!-- <v-row dense justify="center" v-if="emergency_contact_name">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_contact_name.required">*</v-icon>
                    <v-text-field
                        dense
                        type="text"
                        v-model="emergency_contact_name.field_value"
                        :name="emergency_contact_name.field_name"
                        :required="emergency_contact_name.required"
                        :rules="emergency_contact_name.required?[v => !!v || 'Emergency Contact Name is required']:[]"
                        hint="Name"
                        persistent-hint
                        single-line
                        outlined
                        :clearable="emergency_contact_name.required ? false : true"
                        prepend-icon="mdi-account-circle"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="emergency_contact_number">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_contact_number.required">*</v-icon>
                    <v-text-field
                        type="number"
                        v-model="emergency_contact_number.field_value"
                        :name="emergency_contact_number.field_name"
                        :required="emergency_contact_number.required"
                        :rules="emergency_contact_number.required?[
              v => !!v || 'Contact Number is required',
              v => (v && v.length == 10) || 'Contact Number Must be 10 digit'
            ]:[v =>  ((v==null || v=='')?true:(v.length==0||v.length == 10))   || 'Contact Number Must be 10 digit']"
                        counter
                        maxlength="10"
                        hint="Contact No."
                        persistent-hint
                        single-line
                        outlined
                        :clearable="emergency_contact_number.required ? false : true"
                        prepend-icon="mdi-phone-classic"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="emergency_phone_number">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_phone_number.required">*</v-icon>
                    <v-text-field
                        type="number"
                        v-model="emergency_phone_number.field_value"
                        :name="emergency_phone_number.field_name"
                        :required="emergency_phone_number.required"
                        counter
                        hint="Phone / Landline No."
                        persistent-hint
                        single-line
                        outlined
                        :clearable="emergency_phone_number.required ? false : true"
                        prepend-icon="mdi-phone-classic"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="emergency_email">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_email.required">*</v-icon>
                    <v-text-field
                        dense
                        type="text"
                        v-model="emergency_email.field_value"
                        :name="emergency_email.field_name"
                        :required="emergency_email.required"
                        :rules="emergency_email.required ?[
              v => !!v || 'Email is required',
              v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'    
            ]:[v =>((v==null || v=='')?true:(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) )  || 'E-mail must be valid']"
                        hint="Email"
                        persistent-hint
                        single-line
                        outlined
                        :clearable="emergency_email.required ? false : true"
                        prepend-icon="mdi-email"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="emergency_aadhar_no != null">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_aadhar_no.required">*</v-icon>
                    <v-text-field
                        dense
                        v-model="emergency_aadhar_no.field_value"
                        :name="emergency_aadhar_no.field_name"
                        type="number"
                        :required="emergency_aadhar_no.required"
                        :rules="
                    emergency_aadhar_no.required
                        ? [
                            v => !!v || emergency_aadhar_no.field_display_name + ' is required',
                            v =>
                            (v && v.length == 12) ||
                            emergency_aadhar_no.field_display_name + ' must be 12 digit number'
                        ]
                        : [
                            v =>
                            (v == null || v == ''
                                ? true
                                : v.length == 0 || v.length == 12) ||
                            emergency_aadhar_no.field_display_name + ' must be 12 digit number'
                        ]
                    "
                        counter
                        maxlength="12"
                        :clearable="emergency_aadhar_no.required ? false : true"
                        :prepend-icon="
                    emergency_aadhar_no.field_value != null
                        ? 'mdi-alpha-a-circle'
                        : 'mdi-alpha-a-circle-outline'
                    "
                        outlined
                        hint="AADHAR number must be 12 digits"
                        persistent-hint
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="emergency_citizenship != null">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_citizenship.required">*</v-icon>
                    <v-text-field
                        dense
                        v-model="emergency_citizenship.field_value"
                        :name="emergency_citizenship.field_name"
                        type="text"
                        :prepend-icon="
              emergency_citizenship.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            "
                        outlined
                        :required="emergency_citizenship.required"
                        :rules="
              emergency_citizenship.required
                ? [
                    v =>
                      !!v || emergency_citizenship.field_display_name + ' is required'
                  ]
                : []
            "
                        :clearable="emergency_citizenship.required ? false : true"
                        hint="Enter Citizenship"
                        persistent-hint
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="emergency_qualification != null">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_qualification.required">*</v-icon>
                    <v-text-field
                        dense
                        v-model="emergency_qualification.field_value"
                        :name="emergency_qualification.field_name"
                        type="text"
                        :prepend-icon="
              emergency_qualification.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
            "
                        outlined
                        :required="emergency_qualification.required"
                        :rules="
              emergency_qualification.required
                ? [
                    v =>
                      !!v || emergency_qualification.field_display_name + ' is required'
                  ]
                : []
            "
                        :clearable="emergency_qualification.required ? false : true"
                        hint="Enter Qualification"
                        persistent-hint
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="emergency_company_name != null">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_company_name.required">*</v-icon>
                    <v-text-field
                        dense
                        v-model="emergency_company_name.field_value"
                        :name="emergency_company_name.field_name"
                        type="text"
                        :prepend-icon="
              emergency_company_name.field_value != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            "
                        outlined
                        :required="emergency_company_name.required"
                        :rules="
              emergency_company_name.required
                ? [
                    v =>
                      !!v || emergency_company_name.field_display_name + ' is required'
                  ]
                : []
            "
                        :clearable="emergency_company_name.required ? false : true"
                        hint="Enter Company/Organization"
                        persistent-hint
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="emergency_company_address_contact != null">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_company_address_contact.required">*</v-icon>
                    <v-text-field
                        dense
                        v-model="emergency_company_address_contact.field_value"
                        :name="emergency_company_address_contact.field_name"
                        type="text"
                        :prepend-icon="
              emergency_company_address_contact.field_value != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            "
                        outlined
                        :required="emergency_company_address_contact.required"
                        :rules="
              emergency_company_address_contact.required
                ? [
                    v =>
                      !!v || emergency_company_address_contact.field_display_name + ' is required'
                  ]
                : []
            "
                        :clearable="emergency_company_address_contact.required ? false : true"
                        hint="Enter Company/Organization Address & Contact details"
                        persistent-hint
                    ></v-text-field>
                </v-col>
            </v-row>
              <v-row dense justify="center" v-if="emergency_designation != null">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_designation.required">*</v-icon>
                    <v-text-field
                        dense
                        v-model="emergency_designation.field_value"
                        :name="emergency_designation.field_name"
                        type="text"
                        :prepend-icon="
              emergency_designation.field_value != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            "
                        outlined
                        :required="emergency_designation.required"
                        :rules="
              emergency_designation.required
                ? [
                    v =>
                      !!v || emergency_designation.field_display_name + ' is required'
                  ]
                : []
            "
                        :clearable="emergency_designation.required ? false : true"
                        hint="Enter Designation"
                        persistent-hint
                    ></v-text-field>
                </v-col>
            </v-row>
              <v-row dense justify="center" v-if="emergency_occupation != null">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_occupation.required">*</v-icon>
                    <v-text-field
                        dense
                        v-model="emergency_occupation.field_value"
                        :name="emergency_occupation.field_name"
                        type="text"
                        :prepend-icon="
              emergency_occupation.field_value != null
                ? 'mdi-alpha-d-circle'
                : 'mdi-alpha-d-circle-outline'
            "
                        outlined
                        :required="emergency_occupation.required"
                        :rules="
              emergency_occupation.required
                ? [
                    v =>
                      !!v || emergency_occupation.field_display_name + ' is required'
                  ]
                : []
            "
                        :clearable="emergency_occupation.required ? false : true"
                        hint="Enter Occupation"
                        persistent-hint
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-row dense justify="center" v-if="emergency_contact_address">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_contact_address.required">*</v-icon>
                    <v-textarea
                        dense
                        clear-icon="cancel"
                        v-model="emergency_contact_address.field_value"
                        :value="emergency_contact_address.field_value"
                        :name="emergency_contact_address.field_name"
                        :required="emergency_contact_address.reuired"
                        :rules="emergency_contact_address.required?[v => !!v || 'Address is required']:[]"
                        hint="Address"
                        persistent-hint
                        single-line
                        outlined
                        :clearable="emergency_contact_address.required ? false : true"
                        :prepend-icon="emergency_contact_address.field_value!=null?'mdi-home-circle':'mdi-home-circle-outline'"
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="emergency_contact_permanent_address">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_contact_permanent_address.required">*</v-icon>
                    <v-textarea
                        dense
                        clear-icon="cancel"
                        v-model="emergency_contact_permanent_address.field_value"
                        :value="emergency_contact_permanent_address.field_value"
                        :name="emergency_contact_permanent_address.field_name"
                        :required="emergency_contact_permanent_address.reuired"
                        :rules="emergency_contact_permanent_address.required?[v => !!v || 'Permanent Address is required']:[]"
                        hint="Permanent Address"
                        persistent-hint
                        single-line
                        outlined
                        :clearable="emergency_contact_permanent_address.required ? false : true"
                        :prepend-icon="emergency_contact_permanent_address.field_value!=null?'mdi-home-circle':'mdi-home-circle-outline'"
                    ></v-textarea>
                </v-col>
            </v-row>

            <v-row dense justify="center" v-if="emergency_relation">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="emergency_relation.required">*</v-icon>
                    <v-text-field
                        dense
                        type="text"
                        v-model="emergency_relation.field_value"
                        :name="emergency_relation.field_name"
                        :required="emergency_relation.required"
                        :rules="emergency_relation.required?[v => !!v || 'Relationship with the child is required']:[]"
                        hint="Relationship with the child"
                        persistent-hint
                        single-line
                        outlined
                        :clearable="emergency_relation.required ? false : true"
                        prepend-icon="mdi-account-child-outline"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="nationality != null">
                <v-col cols="10" sm="10" md="10">
                    <v-icon color="error" v-if="nationality.required">*</v-icon>
                    <v-autocomplete
                        dense
                        v-model="nationality.field_value"
                        :items="nationality.options"
                        :name="nationality.field_name"
                        :required="nationality.required"
                        :rules="
              nationality.required
                ? [v => !!v || nationality.field_display_name + ' is required']
                : []
            "
                        :clearable="nationality.required ? false : true"
                        return-object
                        single-line
                        :prepend-icon="
              nationality.field_value != null
                ? 'mdi-flag'
                : 'mdi-flag-variant-outline'
            "
                        outlined
                        :hint="nationality.field_display_name"
                        persistent-hint
                    ></v-autocomplete>
                </v-col>
            </v-row> -->

            <v-row justify="center" dense>
                <v-col cols="10" sm="10" md="10">
                    <div style="text-align: center;">
                        <v-btn class="mt-2" :color="isValid ? 'primary darken-1' : 'grey lighten-1'" @click="submit"
                            :disabled="!isValid">Save</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            loader: false,
            isValid: true,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            application_form_data: {
                admission_form_no: "",
                admission_form_id: "",
            },
            disable_personal_email: false,
            disable_mobile_no: false,
            mobile_no: {},
            alternate_mobile_no: {},
            telephone_no: {},
            personal_email: {},
            emergency_contact_name: {},
            emergency_contact_number: {},
            emergency_contact_address: {},
            emergency_contact_permanent_address: {},
            emergency_relation: {},
            emergency_email: {},
            emergency_aadhar_no: {},
            emergency_citizenship: {},
            emergency_qualification: {},
            nationality: {},
            emergency_designation: {},
            emergency_occupation: {},
            emergency_company_name: {},
            emergency_company_address_contact: {},
            emergency_phone_number: {},
            //contact
            tenant: "wws",
            user_type: null,
            guardian_name_sbpps: {},
            guardian_contact_sbpps: {},
            guardian_email_sbpps: {},
            guardian_address_sbpps: {},
            guardian_relation_sbpps: {},
        };
    },
    methods: {
        submit: function (e) {
            this.loader = false;
            var form = document.getElementById("contact_form");
            var formData = new FormData(form);
            axios.post("/admissionForm/saveContact", formData).then(
                (response) => {
                    // success callback
                    console.log(response.data);
                    //this.form_progress=response.data.form_progress

                    if (response.data.form_saved == "YES") {
                        this.showSnackbar("#4caf50", 'Saved Successfully...Click on Next tab to Continue'); // show snackbar on success
                        this.disable_personal_email = true;
                        this.disable_mobile_no = true;
                    }
                    this.loader = true;
                    this.$store.commit("setform_progress", response.data.form_progress);
                },
                (response) => {
                    // error callback
                }
            );
        },
        getform() {
            axios
                .post("/admissionForm/contact", this.application_form_data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.mobile_no = res.data.mobile_no;
                        this.alternate_mobile_no = res.data.alternate_mobile_no;
                        this.telephone_no = res.data.telephone_no;
                        this.personal_email = res.data.personal_email;
                        this.emergency_contact_name = res.data.emergency_contact_name;
                        this.emergency_contact_number = res.data.emergency_contact_number;
                        this.emergency_contact_address = res.data.emergency_contact_address;
                        this.emergency_contact_permanent_address = res.data.emergency_contact_permanent_address;
                        this.emergency_relation = res.data.emergency_relation;
                        this.emergency_email = res.data.emergency_email;
                        this.emergency_aadhar_no = res.data.emergency_aadhar_no;
                        this.nationality = res.data.emergencynationality;
                        this.emergency_occupation = res.data.emergency_occupation;
                        this.emergency_citizenship = res.data.emergency_citizenship;
                        this.emergency_qualification = res.data.emergency_qualification;
                        this.emergency_designation = res.data.emergency_designation;
                        this.emergency_company_address_contact = res.data.emergency_company_address_contact;
                        this.emergency_company_name = res.data.emergency_company_name;
                        this.emergency_phone_number = res.data.emergency_phone_number;

                        this.guardian_name_sbpps = res.data.guardian_name_sbpps
                        this.guardian_contact_sbpps = res.data.guardian_contact_sbpps
                        this.guardian_email_sbpps = res.data.guardian_email_sbpps
                        this.guardian_address_sbpps = res.data.guardian_address_sbpps
                        this.guardian_relation_sbpps = res.data.guardian_relation_sbpps


                        this.loader = true;

                        if (this.personal_email.field_value != null) {
                            this.disable_personal_email = true;
                        }
                        if (this.mobile_no.field_value != null) {
                            this.disable_mobile_no = true;
                        }
                        this.$store.commit("setform_progress", res.data.form_progress);
                        //this.form_progress=res.data.form_progress

                        console.log(res.data);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        console.log("1", this.isValid);
        this.application_form_data = this.$store.getters.application_form_data;
        this.getform();
        console.log("1", this.isValid);
    },
    created() {
        this.tenant = localStorage.getItem("EPS-tenant");
        this.user_type = localStorage.getItem("EPS-ut");
    },
};
</script>
